<template>
  <div>
      <b-row class="m-0 mb-3">
          <b-col cols="1" class="text-center p-2 bg-dark text-white d-flex align-items-center justify-content-center">
              <font-awesome-icon icon="list" class="h2 mb-0" />
          </b-col>
          <b-col class="p-3 bg-danger text-white d-flex align-items-center">
              <div>
                  <h4 class="mb-0"><strong><number-format-component :input_value="Number(remaining_balance)"/></strong></h4>
                  <small class="text-muted text-uppercase font-weight-bold">REMAINING CA BALANCE</small>
              </div>
          </b-col>
      </b-row>
    <b-row class="m-0">
        <b-col class="p-0">
        <fieldset class="border p-3">
            <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">CASH ADVANCES</legend>
            <table class="table table-bordered mb-0 table-sm">
                <thead class="thead-dark">
                <tr>
                    <th>
                        Date
                    </th>
                    <!--<th>-->
                        <!--Check Number-->
                    <!--</th>-->
                    <!--<th>-->
                        <!--Voucher Number-->
                    <!--</th>-->
                    <th>
                        Amount
                    </th>
                    <th>
                        Details
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row_cash_advances, index) in params.cash_advances">
                    <td>{{row_cash_advances.transaction_date}}</td>
                    <!--<td>{{row_cash_advances.check_number}}</td>-->
                    <!--<td>{{row_cash_advances.voucher_number}}</td>-->
                    <td><number-format-component :input_value="Number(row_cash_advances.amount)"/></td>
                    <td>{{row_cash_advances.details}}</td>
                </tr>
                </tbody>
            </table>
            </fieldset>

            <fieldset class="border p-3 mt-3 bg-light">
                <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">CA PAYMENTS</legend>
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>
                            Payroll Coverage
                        </th>
                        <th>
                            Amount Paid
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row_payment, index) in params.payments">
                        <td><b-badge>{{row_payment.date_from}}</b-badge> to <b-badge>{{row_payment.date_to}}</b-badge></td>
                        <td><number-format-component :input_value="Number(row_payment.ca_payment)"/></td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>
        </b-col>
    </b-row>

      <b-modal v-model="modal" centered  size="xl" modal-class="xxl-modal" body-class="p-0" :hide-footer="true" :hide-header="true">
          <div class="card bg-light mb-0">
              <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                  <h6 class="mb-0"><font-awesome-icon icon="list" /> Attendance Details</h6>
              </div>
              <div class="card-body bg-white position-relative">
                  <fieldset class="border p-3 mb-2">
                      <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6 mb-0 text-uppercase">{{row_log.transaction_date}}</legend>
                      <b-row>
                          <b-col>
                              <b-form-group
                                      label="Daily Rate:"
                                      description="This field is required"
                              >
                                  <b-form-input
                                          v-model="row_log.description"
                                          type="text"
                                          disabled
                                  ></b-form-input>
                              </b-form-group>
                          </b-col>
                          <b-col>
                              <b-form-group
                                      label="Daily Rate:"
                                      description="This field is required"
                              >
                                  <b-form-input
                                          v-model="row_log.daily_rate"
                                          type="number"
                                          step="any"
                                          disabled
                                  ></b-form-input>
                              </b-form-group>
                          </b-col>
                          <b-col>
                              <b-form-group
                                      label="Total Regular Hours:"
                                      description="This field is required"
                              >
                                  <b-form-input
                                          v-model="row_log.regular_hours"
                                          type="number"
                                          step="any"
                                          disabled
                                  ></b-form-input>
                              </b-form-group>
                          </b-col>
                          <b-col>
                              <b-form-group
                                      label="Total OT Hours:"
                                      description="This field is required"
                              >
                                  <b-form-input
                                          v-model="row_log.ot_hours"
                                          type="number"
                                          step="any"
                                          disabled
                                  ></b-form-input>
                              </b-form-group>
                          </b-col>
                          <b-col>
                              <b-form-group
                                      label="Options"
                                      description="This will override the computation"
                              >
                                  <b-form-checkbox v-model="row_log.is_modified" name="check-button" switch disabled>
                                      Override Computation
                                  </b-form-checkbox>
                              </b-form-group>
                          </b-col>
                      </b-row>
                      <table class="table border">
                          <thead class="bg-light text-dark">
                          <tr>
                              <th scope="col" class="text-center">AM IN</th>
                              <th scope="col" class="text-center">AM OUT</th>
                              <th scope="col" class="text-center">PM IN</th>
                              <th scope="col" class="text-center">PM OUT</th>
                              <th scope="col" class="text-center">OT IN</th>
                              <th scope="col" class="text-center">OT OUT</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                              <td>
                                  <b-form-input
                                          v-model="row_log.am_in"
                                          type="time"
                                          disabled
                                  ></b-form-input>
                              </td>
                              <td>
                                  <b-form-input
                                          v-model="row_log.am_out"
                                          type="time"
                                          disabled
                                  ></b-form-input>
                              </td>
                              <td>
                                  <b-form-input
                                          v-model="row_log.pm_in"
                                          type="time"
                                          disabled
                                  ></b-form-input>
                              </td>
                              <td>
                                  <b-form-input
                                          v-model="row_log.pm_out"
                                          type="time"
                                          disabled
                                  ></b-form-input>
                              </td>
                              <td>
                                  <b-form-input
                                          v-model="row_log.ot_in"
                                          type="time"
                                          disabled
                                  ></b-form-input>
                              </td>
                              <td>
                                  <b-form-input
                                          v-model="row_log.ot_out"
                                          type="time"
                                          disabled
                                  ></b-form-input>
                              </td>
                          </tr>
                          </tbody>
                      </table>
                  </fieldset>
              </div>
          </div>
      </b-modal>
  </div>
</template>
<script>

    import SwalMixin from "@/views/mixins/Swal.js";
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
        mixins:[SwalMixin],
        components: {NumberFormatComponent},
        props:{
            params: {
                type: Object,
                default: {},
                required: true
            },
        },
        data() {
            return {
                modal:false,
                row_log:{}
            }
        },
        computed: {
            remaining_balance(){
                let ca = 0;
                let payment = 0;
                if(this.params.cash_advances.length!=0){
                    ca = this.params.cash_advances.reduce((total, value)=>{
                        return total + Number(value.amount);
                    },0);
                }

                if(this.params.payments.length!=0){
                    payment = this.params.payments.reduce((total, value)=>{
                        return total + Number(value.ca_payment);
                    },0);
                }

                return Number(ca-payment);
            },
        },
        methods:{
            deleteSocialMedia(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/social-media/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });
                
            },
            save(){
                this.$emit('save');
                this.modal=false;
            },
            viewDetails(row_log){
                this.modal=true;
                this.row_log = row_log;
            }
        }
    }
</script>
